import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import Image from '../../../../../../atoms/Image';
import { ImagePropType } from '../../../../../../services/proptypes';
import { classNames } from '../../../../../../utils/classname';
import './Photo.css';
var defaultProps = {
  src: null,
  onClick: null
};
export default function Photo(_ref) {
  var src = _ref.src,
    onClick = _ref.onClick;
  if (_isEmpty(src)) {
    return null;
  }
  var className = classNames({
    'photo-container': true,
    clickable: !!onClick
  });
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(Image, {
    className: "photo",
    src: src,
    onClick: onClick
  }));
}
Photo.defaultProps = defaultProps;